// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProviderAddressInfoDto } from './IProviderAddressInfoDto';
import {
    IProviderAddressInfoDtoFromJSON,
    IProviderAddressInfoDtoFromJSONTyped,
    IProviderAddressInfoDtoToJSON,
    IProviderAddressInfoDtoToJSONTyped,
} from './IProviderAddressInfoDto';

/**
 * 
 * @export
 * @interface IProviderInfoDto
 */
export interface IProviderInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IProviderInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProviderInfoDto
     */
    facility_name: string;
    /**
     * 
     * @type {string}
     * @memberof IProviderInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IProviderInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IProviderInfoDto
     */
    tax_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IProviderInfoDto
     */
    card_acceptor_id?: string;
    /**
     * 
     * @type {Array<IProviderAddressInfoDto>}
     * @memberof IProviderInfoDto
     */
    addresses?: Array<IProviderAddressInfoDto>;
}

/**
 * Check if a given object implements the IProviderInfoDto interface.
 */
export function instanceOfIProviderInfoDto(value: object): value is IProviderInfoDto {
    if (!('facility_name' in value) || value['facility_name'] === undefined) return false;
    return true;
}

export function IProviderInfoDtoFromJSON(json: any): IProviderInfoDto {
    return IProviderInfoDtoFromJSONTyped(json, false);
}

export function IProviderInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProviderInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_name': json['facility_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'card_acceptor_id': json['card_acceptor_id'] == null ? undefined : json['card_acceptor_id'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(IProviderAddressInfoDtoFromJSON)),
    };
}

export function IProviderInfoDtoToJSON(json: any): IProviderInfoDto {
    return IProviderInfoDtoToJSONTyped(json, false);
}

export function IProviderInfoDtoToJSONTyped(value?: IProviderInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_name': value['facility_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'tax_id': value['tax_id'],
        'card_acceptor_id': value['card_acceptor_id'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(IProviderAddressInfoDtoToJSON)),
    };
}

